import React from "react";

export const NotFoundWarningIcon = () => (
  <svg
    className="not-found-page__icon"
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.6437 8.60765C39.5056 8.22451 40.4897 8.22456 41.3517 8.60765C42.3401 9.04716 43.0982 10.3567 44.6134 12.9739L72.0294 60.3284C73.5501 62.955 74.3108 64.269 74.1984 65.3469C74.1003 66.287 73.6074 67.1417 72.8429 67.6975C71.9663 68.3345 70.4487 68.3342 67.4142 68.3342H12.5812C9.54666 68.3342 8.02902 68.3346 7.15248 67.6975C6.38801 67.1417 5.89508 66.287 5.79701 65.3469C5.68464 64.269 6.44528 62.955 7.96596 60.3284L35.382 12.9739C36.8972 10.3566 37.6553 9.04716 38.6437 8.60765ZM40.0001 53.6672C38.3433 53.6673 37.0001 55.0104 37.0001 56.6672C37.0003 58.3239 38.3434 59.6672 40.0001 59.6672H40.0333C41.6901 59.6672 43.0332 58.3239 43.0333 56.6672C43.0333 55.0104 41.6902 53.6672 40.0333 53.6672H40.0001ZM40.0001 27.0002C38.3433 27.0003 37.0001 28.3434 37.0001 30.0002V43.3332C37.0001 44.9901 38.3433 46.3332 40.0001 46.3332C41.657 46.3332 43.0001 44.9901 43.0001 43.3332V30.0002C43.0001 28.3434 41.657 27.0002 40.0001 27.0002Z"
      fill="#1E3A6D"
    />
  </svg>
);
